"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var SimpleCard_1 = __importDefault(require("../DeveloperSectionContainer/SimpleCard"));
var BuildingCard_1 = __importDefault(require("../DeveloperSectionContainer/BuildingCard"));
var ApartmentCard_1 = __importDefault(require("./ApartmentCard"));
var PostTabsContext_1 = require("../../../../../contexts/PostTabsContext");
var PropertyTypes_1 = require("../../../../../types/SearchPage/PropertyTypes");
var StructureType_1 = require("../../../../../types/SearchPage/StructureType");
var PersonalSectionContainer = function (_a) {
    var _b, _c, _d, _e, _f, _g;
    var steps = _a.steps, formikProps = _a.formikProps, post = _a.post, isLoaded = _a.isLoaded, removeParentEntityMedia = _a.removeParentEntityMedia, reorderMedia = _a.reorderMedia;
    var handleChangeSchema = react_1.useContext(PostTabsContext_1.PostTabsContext).handleChangeSchema;
    react_1.useEffect(function () {
        handleChangeSchema({
            deal: formikProps.values.deal,
            propertyType: formikProps.values.initial_info.property_type,
        });
    }, [
        formikProps.values.deal,
        formikProps.values.initial_info.property_type,
    ]);
    // 1. Land has no building: the hidden new/secondary field must not keep its
    //    default "new_building", otherwise the building rows show up and the
    //    plot is saved as a new build. Land gets the "no building" marker.
    // 2. Leaving land restores the form's default, so the field works as before.
    react_1.useEffect(function () {
        var _a = formikProps.values.initial_info, property_type = _a.property_type, structure_type = _a.structure_type;
        var isLand = property_type === PropertyTypes_1.PROPERTY_TYPE.LAND;
        if (isLand && structure_type !== StructureType_1.STRUCTURE_TYPE.NO_BUILDING) {
            formikProps.setFieldValue('initial_info.structure_type', StructureType_1.STRUCTURE_TYPE.NO_BUILDING);
        }
        if (!isLand && structure_type === StructureType_1.STRUCTURE_TYPE.NO_BUILDING) {
            formikProps.setFieldValue('initial_info.structure_type', StructureType_1.STRUCTURE_TYPE.NEW_BUILDING);
        }
    }, [formikProps.values.initial_info.property_type]);
    // Same rule as the steps menu: the building section is shown only for the
    // property types listed in its config (land is not listed - no building).
    var isBuildingVisible = (_g = (_f = (_e = (_d = (_c = (_b = steps[2]) === null || _b === void 0 ? void 0 : _b.config) === null || _c === void 0 ? void 0 : _c.displayCondition) === null || _d === void 0 ? void 0 : _d.visibleSections) === null || _e === void 0 ? void 0 : _e.propertyType) === null || _f === void 0 ? void 0 : _f.includes(formikProps.values.initial_info.property_type)) !== null && _g !== void 0 ? _g : true;
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(SimpleCard_1.default, { step: steps[0], formikProps: formikProps, post: post, isLoaded: isLoaded, reorderMedia: reorderMedia }),
        react_1.default.createElement(SimpleCard_1.default, { step: steps[1], formikProps: formikProps, post: post, isLoaded: isLoaded, reorderMedia: reorderMedia }),
        isBuildingVisible && (react_1.default.createElement(BuildingCard_1.default, { step: steps[2], formikProps: formikProps, post: post, isLoaded: isLoaded, removeParentEntityMedia: removeParentEntityMedia, reorderMedia: reorderMedia })),
        react_1.default.createElement(ApartmentCard_1.default, { step: steps[3], formikProps: formikProps, post: post, isLoaded: isLoaded }),
        react_1.default.createElement(SimpleCard_1.default, { step: steps[4], formikProps: formikProps, post: post, isLoaded: isLoaded, reorderMedia: reorderMedia })));
};
exports.default = PersonalSectionContainer;
